import React from 'react';
import { Link } from 'react-router-dom';
import type { ReportSummaryModelV1 } from '../../../lib/reportSummary/types';
import { reportReaderPath, siteOverviewPath } from '../../../lib/siteNavigation';

export function ReportSummaryToolbar({ model, pageSize: _pageSize, pending, onPageSize: _onPageSize, onDownload }: {
  model: ReportSummaryModelV1; pageSize?: 'A4' | 'Letter'; pending: boolean;
  onPageSize?: (size: 'A4' | 'Letter') => void; onDownload: () => void;
}) {
  const identity = model.identity;
  const siteId = identity.siteId ?? '';
  const versionText = `${identity.sourceVersion.major}.${identity.sourceVersion.minor}`;
  const generatedDateText = identity.sourceGeneratedAt ? identity.sourceGeneratedAt.slice(0, 10) : '';
  return <>
    <nav className="rs-toolbar print:hidden" data-screen-only-cta aria-label="Report summary actions">
      <Link to={siteOverviewPath(siteId, 'reports')}>‹ Analyses</Link>
      <div className="rs-toolbar-title"><strong>{model.title}</strong><span>{identity.siteName} · Report version {versionText} · Generated {generatedDateText}</span></div>
      <div className="rs-toolbar-actions">
        <Link to={reportReaderPath(siteId, identity.reportId)}>Open full report</Link>
        <button disabled={pending} onClick={onDownload}>{pending ? 'Building PDF…' : 'Download PDF'}</button>
      </div>
    </nav>
  </>;
}
